import type { AnyBlock, ImageBlock } from "@/types";

/** Soft, advisory warnings (§8) — never block saving. `subject` lets the same
 *  checks read naturally for a quote or a template. */
export function buildWarnings(blocks: AnyBlock[], subject: "quote" | "template" = "quote"): string[] {
  const warnings: string[] = [];
  const count = (type: string) => blocks.filter((b) => b.type === type).length;

  if (count("accept") === 0) {
    warnings.push(`This ${subject} has no Accept block, so the client won't be able to accept it online.`);
  }

  const pricing = count("pricing");
  if (pricing === 0) {
    warnings.push("No pricing block — the client won't see the fee breakdown.");
  } else if (pricing > 1) {
    warnings.push("Multiple pricing blocks will each show the full fee table.");
  }

  const emptyImage = blocks.some(
    (b) => b.type === "image" && !(b as ImageBlock).props?.asset_url,
  );
  if (emptyImage) {
    warnings.push("An image block has no image yet.");
  }

  return warnings;
}
